const InitialData = {
    error: false,
    msg: "",
    BookAppointmentData: { BAStep: 1, TAStep: 1, Tab: "newBook", error: {} },
    PickDropData: { PDStep: 1, Tab: "newBook",selectedAddressData:{}, error: {} },
    location: { loaded: false, coordinates: { lat: "", lng: "" } },
    SpareRepaireData: {},
    DiyData: { search: "", searchBy: 2, filterType: "All", filterOpp: [] ,isGlobalSearch: false},
    TrackDetailsData: {error:{},SlectedRequest:{showfeedback:false}},
    RequestCallBackAgentData: {error:{},SlectedRequest:{}},
    SPLocationData:{error:{},SelectedcSeller:null,product:'',selectedProduct:null},
    ExtendedHourSCData:{error:{},SelectedcSeller:null,product:'',selectedProduct:null},
    CategoryCodeSprinklrData : [{ 'Category': 'HHP', 'Code': 'HHP' }, { 'Category': 'VDE', 'Code': 'AV' }, { 'Category': 'REF', 'Code': 'HA' }, { 'Category': 'WSM', 'Code': 'HA' }, { 'Category': 'ACN', 'Code': 'HA' }, { 'Category': 'COM', 'Code': 'NPC' },]
    // SPLocationData:{error:{},SelectedcSeller:null,product:'HHP',selectedProduct:{'value': "HHP", 'label': "Mobile"}}
};
export default InitialData;
